import { APP_COUNTRY } from 'config';
import { useSelector, useStore } from 'react-redux';
import { selectFromOAuth } from 'services/oauth/oauth.selectors';
import { selectSessionInfo } from 'services/session/session.selectors';
import { AppChannel } from 'utils/config.config';

export function useIsWarningBannerHidden() {
  const reduxStore = useStore();
  const fromOAuth = useSelector(selectFromOAuth);
  const { channel } = selectSessionInfo(reduxStore.getState());
  const countriesWithBanner = ['fr'];

  return (
    !countriesWithBanner.includes(APP_COUNTRY) ||
    fromOAuth ||
    channel === AppChannel.ClientDesktopSisalPoker
  );
}
